<!-- eslint-disable -->

<template>
	<div class="container">
		<div class="d-flex mx-auto mt-4" style="max-width: 360px;height: 160px;">
			<img class="image-fit" src="@/assets/images/stop-rent-locker-icon.svg" alt="locker_success" style="width: 100%;"/>
		</div>
		<span class="text-center text-gotham-bold" style="font-size: 40px;color: #5f51a1;" v-html="text"></span>
		<div class="ring">
			<CountDown
				onlySecond
				noZeroPrefix
				:num="num"
				@onTimerEnd="handleEnd"
				@onTick="seconds => (num = seconds)"
				countStyle="font-size:48px;"
			/>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import CountDown from '../components/CountDown.vue';

export default {
	components: {
		CountDown,
	},
	data() {
		return {
			num: 5,
			instruction:"",
		};
	},
	computed: {
		text() {
			return this.language === 'en'
				? this.instruction?.description
				: this.instruction?.description_bahasa;
		},
	},
	methods: {
		handleEnd() {
			const { query } = this.$route;
			this.$router.replace(`/order-status${this.objectToQuery({ obj: query })}`);
		},
	},
	mounted(){
		this.instruction = this.getPaxelBoxContentSetting("stop_rent_countdown_instruction")
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: calc(100vh - 150px);
	gap: 18px;
}

.ring {
	display: flex;
	justify-content: center;
	align-items: center;
	border: 2px solid #5f51a1;
	border-radius: 50%;
	min-width: 60px;
	min-height: 60px;
}
</style>
